import React from 'react'

const PaymentErrorPage = () => {
  return (
    <div>
       Payment Failed...
    </div>
  )
}

export default PaymentErrorPage
